export default __webpack_public_path__ + "static/team-cover-alt-f4ba64ec8db624fa3d910a3d7ec012be.jpg";